import React from "react";
import { CompositeDecorator } from "draft-js";

const findDynamicEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "DYNAMICFIELD"
    );
  }, callback);
};

const handleDynamicField = props => (
  // const data = props.contentState.getEntity(props.entityKey).getData();
  <span className="dynamic-field" contenteditable="false">{props.children}</span>
);

const findHighlightNotes = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "NOTES"
    );
  }, callback);
};

const handleHighlightNotes = props => (
  // const data = props.contentState.getEntity(props.entityKey).getData();
  <span className="document-highlight">{props.children}</span>
);

const findComments = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "COMMENTS"
    );
  }, callback);
};

const handleComments = props => (
  // const data = props.contentState.getEntity(props.entityKey).getData();
  <span className="document-comments">{props.children}</span>
);

// Linkify Draft State
function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
}

const handleLinks = props => {
  const { url } = props.contentState.getEntity(props.entityKey).getData();
  return (
    <a href={url} rel="noopener noreferrer" target="_blank" className="document-links">
      {props.children}
    </a>
  );
};

const getCompositeDecorator = () => {
  const compositeDecorator = new CompositeDecorator([
    {
      strategy: findDynamicEntities,
      component: handleDynamicField,
    },
    {
      strategy: findHighlightNotes,
      component: handleHighlightNotes,
    },
    {
      strategy: findLinkEntities,
      component: handleLinks,
    },
    {
      strategy: findComments,
      component: handleComments,
    },
  ]);
  return compositeDecorator;
};

export default getCompositeDecorator;
